import { Avatar, AvatarProps } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import UserIcon from '../Icons/User';

const StyledAvatar = styled(Avatar)`
    background-color: rgba(17, 17, 17, 0.6);
`;

export interface UserAvatarProps extends AvatarProps {}

const UserAvatar: React.FC<UserAvatarProps> = ({ ...props }) => {
    return (
        <StyledAvatar {...props}>
            <UserIcon />
        </StyledAvatar>
    );
};

export default UserAvatar;
